/**
 * Apollo Client Configuration for SSR
 *
 * Includes tenant context headers for data isolation (Requirement 11.4)
 */

import {
  createApolloClient,
  setTenantContext,
  getTenantContext,
  createTenantHeaders,
} from '@bloomcode/apollo';
import { config } from '@/config/env';

export const apolloClient = createApolloClient({
  graphqlEndpoint: config.graphqlEndpoint,
  enableLogging: config.loggingEnabled,
  customHeaders: createTenantHeaders,
  // Handle session expiration (Requirement 11.5)
  onSessionExpired: () => {
    if (typeof window !== 'undefined') {
      const returnUrl = encodeURIComponent(window.location.pathname + window.location.search);
      window.location.href = `/auth/login?returnUrl=${returnUrl}&reason=session_expired`;
    }
  },
  onAuthError: () => {
    if (typeof window !== 'undefined') {
      const returnUrl = encodeURIComponent(window.location.pathname + window.location.search);
      window.location.href = `/auth/login?returnUrl=${returnUrl}`;
    }
  },
});

export { setTenantContext, getTenantContext };
